import { useCallback, useContext, useEffect, useState } from "react";
import { AiOutlineCamera } from "react-icons/ai";
import axios from "axios";

import {  UserContext } from "../../../../context";
import { ArrowNotification } from "../../../atoms";
import PinkNotification from "../../Notification/PinkNotification";
import { useTranslation } from "react-i18next";

const UploadProfileImage = () => {
	const { t } = useTranslation();
	const { userData } = useContext(UserContext);
	const [profilePicture, setProfilePicture] = useState<File>();
	const [isIconHovered, setIsIconHovered] = useState<boolean>();

	const updateThePicture = useCallback(() => {
		if (!profilePicture)return;

		const formData = new FormData();
		const email: string = userData?.email || "";

		const windowLocationHref = window.location.href;
		const urlPathChunks = windowLocationHref.split("/");
		const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

		formData.append("email", email);
		formData.append("matchId", urlTokenExtracted);
		formData.append("profilePicture", profilePicture || createEmptyFile());

		axios
			.post(
				process.env.REACT_APP_BACKEND_URL +"api/matches/upload-profile-picture",
				formData,
				{
					headers: {
						"Content-type": "multipart/form-data",
					},
				}
			)
			.catch((err) => console.error(err) );
	}, [profilePicture, userData?.email]);

	useEffect(() => {
		updateThePicture();
	}, [updateThePicture]);

	const createEmptyFile = (): File => {
		return new File([], "");
	};

	const fileSelectedHandler = (e: any) => {
		const imageFile = e.target.files[0];
		
		if (imageFile?.type !== "image/jpeg" && imageFile?.type !== "image/png") {
			alert(t("onlyPngOrJpgAllowedText"));
			return;
		}
		let fileSizeIniMiB = imageFile?.size / 1024 / 1024;

		if (fileSizeIniMiB > 2) {
			alert(t("fileSizeExceedsText"));
			return;
		}

		if (!imageFile) return;

		setProfilePicture(imageFile);

	};

	return (
		<div>
			<input accept="image/*"  style={{display:'none'}} id="icon-button-file" type="file" onChange={fileSelectedHandler} />
			<label htmlFor="icon-button-file">

				<div className="edit_profile_picture" onMouseEnter={() => setIsIconHovered(true)} onMouseLeave={() => setIsIconHovered(false)} style={{zIndex: 11, backgroundColor:'#DC3C95', borderRadius:'30px', width:'30px', height:'30px', textAlign:'center', paddingTop:'2px'}}>

					{isIconHovered && <div style={{zIndex: -1, position: "relative", top: "14px", transform: "scale(0.7", transformOrigin: "right"}} > <PinkNotification notificationWidthVW={22} notificationRenderingSide="left" text={t("ediImageInstructionsText")} /> </div> }
					<div style={{zIndex: 10}}> <AiOutlineCamera   size="25"/> </div>
				</div>
			</label>
		</div>
	);
};

export default UploadProfileImage;